const AdminMenuPageEnum = {
    LANDING : 0,
    ACTIVITY : 1,
    QUIZ : 2,
};
Object.freeze(AdminMenuPageEnum);
export default AdminMenuPageEnum;